var AttributeSetsList = React.createClass({
  propTypes: {
    attributeSets: React.PropTypes.array.isRequired,
    onAttributeSetChanged: React.PropTypes.func
  },
  getItem(set) {
    return (
      <li className="filter__item" key={set.value}>
        <a href="#" className="filter__link" onClick={this.setClicked.bind(this, set.value)}>{set.value}</a>
      </li>
    )
  },
  setClicked(setName) {
    if (this.props.onAttributeSetChanged) {
      this.props.onAttributeSetChanged(setName);
    }
  },

  render() {
    return (
      <ul className="filter__list">
        {this.props.attributeSets.map(this.getItem)}
      </ul>
    )
  }
});